import React, { useMemo } from "react";
import useStats from "../hooks/useStats";
import StatsTable from "./common/StatsTable";
import TIME_PERIODS from "./constants/periods";

const RESOURCE = "/v1/statistics/voice_calls";
const INITIAL_STATE = {};

const CallStats = () => {
  const { data: callStats, loading } = useStats({
    resource: RESOURCE,
    initialState: INITIAL_STATE,
  });

  const columns = useMemo(
    () => [
      { header: "Call usage minutes", id: "usage", className: "w-50" },
      { header: "Inbound", id: "inbound", className: "w-20 text-center" },
      { header: "Outbound", id: "outbound", className: "w-20 text-center" },
    ],
    [],
  );

  const rows = useMemo(
    () => [
      {
        period: TIME_PERIODS.TODAY,
        values: [
          { id: "inbound-today", value: callStats.inboundCallsToday },
          { id: "outbound-today", value: callStats.outboundCallsToday },
        ],
      },
      {
        period: TIME_PERIODS.THIS_WEEK,
        values: [
          { id: "inbound-week", value: callStats.inboundCallsThisWeek },
          { id: "outbound-week", value: callStats.outboundCallsThisWeek },
        ],
      },
      {
        period: TIME_PERIODS.THIS_MONTH,
        values: [
          { id: "inbound-month", value: callStats.inboundCallsThisMonth },
          { id: "outbound-month", value: callStats.outboundCallsThisMonth },
        ],
      },
      {
        period: TIME_PERIODS.LAST_MONTH,
        values: [
          { id: "inbound-last-month", value: callStats.inboundCallsLastMonth },
          {
            id: "outbound-last-month",
            value: callStats.outboundCallsLastMonth,
          },
        ],
      },
    ],
    [callStats],
  );

  return (
    <StatsTable
      title="Call usage minutes"
      columns={columns}
      rows={rows}
      loading={loading}
    />
  );
};

export default React.memo(CallStats);
